import * as React from "react";
import { ProductDetails } from "./ProductDetails";
import Badge from "./Badge";
import ShopifyProduct from "../../interface/ShopifyProduct";
import Theme from "../../interface/Theme";
import ProductColourVariation from "../../interface/ProductColourVariation";
import { ProductSectionSettings } from "../../interface/ProductSectionSettings";
import { FindInStore } from "../FindInStore/FindInStore";

interface ProductPageProps {
  product: ShopifyProduct;
  customFields: any;
  colourVariations: ProductColourVariation[];
  productSectionSettings: ProductSectionSettings;
  theme: Theme;
}

const ProductPage = (props: ProductPageProps) => {
  const { product, customFields, colourVariations, productSectionSettings, theme } = props;
  const badgeDisplayElement = document.getElementsByClassName("product__gallery-wrapper")[0];
  return (
    <>
      <Badge
        title={customFields.badge_text}
        textColor={customFields.badge_text_colour}
        backColor={customFields.badge_background_colour}
        displayContainer={badgeDisplayElement}
      />

      <ProductDetails
        product={product}
        customFields={customFields}
        colourVariations={colourVariations}
        productSectionSettings={productSectionSettings}
        moneyFormat={theme.moneyFormat}
        afterpayEnabled={theme.afterpayEnabled}
      />

      <FindInStore product={product} moneyFormat={theme.moneyFormat} />
    </>
  );
};

export default ProductPage;
